import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { Clock } from 'lucide-react';
export function UrgencyBar() {
  const [timeLeft, setTimeLeft] = useState(4 * 60 + 57); // 4:57 in seconds
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => prev > 0 ? prev - 1 : 0);
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const minutes = Math.floor(timeLeft / 60);
  const seconds = timeLeft % 60;
  return <motion.div initial={{
    y: -50
  }} animate={{
    y: 0
  }} className="sticky top-0 z-50 w-full bg-burgundy border-b border-champagne-gold/30 shadow-burgundy-glow" data-id="element-254">
      <div className="max-w-7xl mx-auto px-4 py-3 flex flex-col sm:flex-row items-center justify-center gap-2 sm:gap-4 text-center" data-id="element-255">
        <span className="text-champagne-gold font-semibold tracking-wider text-xs sm:text-sm uppercase flex items-center gap-2" data-id="element-256">
          <span className="animate-pulse" data-id="element-257">🔥</span> OFFRE DE LANCEMENT : -90%
        </span>
        <div className="flex items-center gap-1.5 bg-deep-black/40 px-3 py-1 rounded-full border border-champagne-gold/20" data-id="element-258">
          <Clock size={14} className="text-champagne-gold" data-id="element-259" />
          <span className="text-champagne-gold font-mono font-bold text-sm" data-id="element-260">
            Plus que {String(minutes).padStart(2, '0')}:
            {String(seconds).padStart(2, '0')}...
          </span>
        </div>
      </div>
    </motion.div>;
}